jQuery(document).ready(function($) {
  if(document.referrer && (document.referrer =! '') ) {  
    var url = document.referrer;
    //console.log(document.referrer);
    var urls = url.split("://"); //console.log(urls);
    var urls = urls[1].split("/"); //console.log(urls);
    if('nutribe.fr' != urls[0]){
      var loc = window.location.href; //console.log(window.location);
      Cookies.set('nutribe_referrer', url);
      var ref= loc.split("?");
      if(ref[1]){
        ref= ref[1].split("=");
        //console.log( ref[1] );
        Cookies.set( 'nutribe_referrer_id', ref[1] );
      }else{Cookies.set( 'nutribe_referrer_id', "" );}
    }
    if(Cookies.get('nutribe_referrer') && $('input.cart_landing_site_ref').length > 0 ){
      console.log('cookie : '+Cookies.get('nutribe_referrer'));
      $('input.cart_landing_site_ref').val(Cookies.get('nutribe_referrer'));
      if(Cookies.get('nutribe_referrer_id')){
        console.log('cookie : '+Cookies.get('nutribe_referrer_id'));
        $('input.cart_landing_site_ref_id').val(Cookies.get('nutribe_referrer_id'));
      }
    }        
  } 
}); 